/* eslint-disable react-refresh/only-export-components */
import {
  type UploadedImage as UploadedImageType,
  FileStatus,
} from '@/lib/types';
import DeleteUploadedImage from './DeleteUploadedImage';
import ImagePreviewLoadingState from './ImagePreviewLoadingState';
import useUploadedImageFileStatusRefreshing from './useUploadedImageFileStatusRefreshing';
import FileChip from '../FileChip';
import ImageErrorState from './ImageErrorState';
import ImagePreview from './ImagePreview';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';

export const fileErrorStates = [
  FileStatus.ANTIVIRUS_QUARANTINED,
  FileStatus.INAPPROPRIATE_CONTENT_DETECTED,
];

type UploadedImageProps = {
  image: UploadedImageType;
};

const UploadedImage = ({ image }: UploadedImageProps) => {
  useUploadedImageFileStatusRefreshing(image);

  const showErrorState = fileErrorStates.includes(image.file.status);

  return (
    <FileChip useErrorMode={showErrorState}>
      {image.file.status === FileStatus.READY ? (
        <ImagePreview image={image} />
      ) : showErrorState ? (
        <ImageErrorState image={image} />
      ) : (
        <ImagePreviewLoadingState imageFilename={image.file.originalFilename} />
      )}
      <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
        <DeleteUploadedImage image={image} useErrorMode={showErrorState} />
      </RestrictedToPortfolioMode>
    </FileChip>
  );
};

export default UploadedImage;
